<template>
  <div>
    <!-- Versão Desktop - Tabela -->
    <div class="row desktop-view">
      <div class="col-md-12">
        <div v-if="checklistsAvulsasEnabled" class="mb-3 d-flex justify-content-end">
          <button
            class="btn"
            :class="modoAvulso ? 'btn-secondary' : 'btn-primary'"
            @click="toggleModoAvulso"
          >
            <i :class="modoAvulso ? 'fas fa-calendar-alt' : 'fas fa-list-alt'"></i>
            {{ modoAvulso ? 'Ver Agendados' : 'Executar Checklist Avulsa' }}
          </button>
        </div>

        <base-crud
          :key="crudKey"
          :ref="'checklistsCrud'"
          :crudName="modoAvulso ? 'Checklists Disponíveis' : 'Executar Checklists'"
          newText="Executar"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>

    <!-- Versão Mobile - Cards -->
    <div class="mobile-view">
      <div class="mobile-header">
        <h2 class="mobile-title">{{ modoAvulso ? 'Checklists Disponíveis' : 'Executar Checklists' }}</h2>
        <div v-if="checklistsAvulsasEnabled" class="mt-2">
          <button
            class="btn btn-sm"
            :class="modoAvulso ? 'btn-secondary' : 'btn-primary'"
            @click="toggleModoAvulso"
          >
            <i :class="modoAvulso ? 'fas fa-calendar-alt' : 'fas fa-list-alt'"></i>
            {{ modoAvulso ? 'Ver Agendados' : 'Executar Checklist Avulsa' }}
          </button>
        </div>
      </div>

      <div class="mobile-cards-container">
        <div 
          v-for="checklist in mobileChecklists" 
          :key="checklist.id"
          class="checklist-card"
        >
          <div class="card-header-line">
            <div class="card-id">
              <span class="id-badge">#{{ checklist.id }}</span>
            </div>
            <div class="card-status" v-if="!modoAvulso">
              <span 
                class="status-badge"
                :class="getStatusClass(checklist.status)"
              >
                {{ getStatusText(checklist.status) }}
              </span>
            </div>
            <div class="card-status" v-else>
              <span class="status-badge status-disponivel">Avulsa</span>
            </div>
          </div>

          <div class="card-body">
            <div class="card-info-row">
              <div class="info-label">
                <i class="fas fa-clipboard-list"></i>
                Checklist
              </div>
              <div class="info-value">
                {{ getChecklistName(checklist) }}
              </div>
            </div>

            <div class="card-info-row" v-if="!modoAvulso">
              <div class="info-label">
                <i class="fas fa-map-marker-alt"></i>
                Unidade
              </div>
              <div class="info-value">
                {{ getUnitName(checklist) }}
              </div>
            </div>

            <template v-if="!modoAvulso">
              <div class="card-info-row">
                <div class="info-label">
                  <i class="fas fa-clock"></i>
                  Agendado
                </div>
                <div class="info-value">
                  {{ formatDateTime(checklist.data_hora_agendada) }}
                </div>
              </div>

              <div class="card-info-row">
                <div class="info-label">
                  <i class="fas fa-hourglass-end"></i>
                  Disponível Até
                </div>
                <div class="info-value">
                  {{ formatDateTime(checklist.data_hora_fim) }}
                </div>
              </div>
            </template>
          </div>

          <div class="card-footer">
            <button 
              class="btn-execute"
              @click="executeChecklist(checklist.id)"
            >
              <i class="fas fa-play"></i>
              {{ modoAvulso ? 'Executar Avulso' : 'Executar Checklist' }}
            </button>
          </div>
        </div>

        <div v-if="mobileChecklists.length === 0" class="no-data-message">
          <i class="fas fa-inbox fa-3x"></i>
          <p>Nenhum checklist agendado disponível</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },

  data() {
    return {
      crudKey: 0,
      modoAvulso: false,
      checklistsAvulsasEnabled: false,
      table: "checklistTemplatesCrud",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      mobileChecklists: [],
      columns: [
        "id",
        "checklist_name",
        "unit_name",
        "data_hora_agendada",
        "data_hora_fim",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "checklist_name",
        "unit_name",
        "data_hora_agendada",
        "data_hora_fim",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "checklist_name",
          "unit_name",
          "status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          checklist_name: "Checklist",
          unit_name: "Unidade",
          data_hora_agendada: "Horário Agendado",
          data_hora_fim: "Disponível Até",
          status: "Status",
          actions: "Ações",
        },
        sortable: [
          "id",
          "checklist_name",
          "unit_name",
          "data_hora_agendada",
          "data_hora_fim",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            { id: "0", text: "Disponível" },
            { id: "1", text: "Aguardando Preenchimento" },
            { id: "2", text: "Finalizada" },
            { id: "3", text: "Não Preenchida" },
            { id: "4", text: "Parcialmente Preenchida" },
          ],
        },
        templates: {
          checklist_name: function (h, row) {
            return row.checklist_template && row.checklist_template.nome
              ? row.checklist_template.nome
              : "-";
          },

          unit_name: function (h, row) {
            return row.unit && row.unit.name ? row.unit.name : "-";
          },

          data_hora_agendada: function (h, row) {
            if (!row.data_hora_agendada) return "-";

            return new Date(row.data_hora_agendada).toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });
          },

          data_hora_fim: function (h, row) {
            if (!row.data_hora_fim) return "-";

            return new Date(row.data_hora_fim).toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });
          },

          status: function (h, row) {
            // Status numéricos: 0=disponivel, 1=aguardando_preenchimento, 2=finalizada, 3=nao_preenchida, 4=parcialmente_preenchida
            if (row.status === 0 || row.status === "disponivel") {
              return (
                <h5>
                  <span class="badge badge-primary">Disponível</span>
                </h5>
              );
            }

            if (row.status === 1 || row.status === "aguardando_preenchimento") {
              return (
                <h5>
                  <span class="badge badge-warning">Aguardando Preenchimento</span>
                </h5>
              );
            }

            if (row.status === 2 || row.status === "finalizada") {
              return (
                <h5>
                  <span class="badge badge-success">Finalizada</span>
                </h5>
              );
            }

            if (row.status === 3 || row.status === "nao_preenchida") {
              return (
                <h5>
                  <span class="badge badge-danger">Não Preenchida</span>
                </h5>
              );
            }

            if (row.status === 4 || row.status === "parcialmente_preenchida") {
              return (
                <h5>
                  <span class="badge badge-warning">Parcialmente Preenchida</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">
                  {row.status || "Desconhecido"}
                </span>
              </h5>
            );
          },

          actions: function (h, row) {
            const vm = this;

            return h(
              "button",
              {
                class: "btn btn-crud edit",
                attrs: {
                  title: "Executar Checklist",
                  type: "button",
                },
                on: {
                  click: () => {
                    if (!row.id) {
                      return;
                    }

                    vm.$router.push(`/checklists/view/${row.id}`);
                  },
                },
              },
              [
                h("i", {
                  class: "fas fa-play",
                  attrs: {
                    "data-toggle": "tooltip",
                    title: "Executar",
                  },
                }),
              ]
            );
          },
        },

        requestFunction: function (data) {
          const requestData = {};
          const query = this.$parent.$parent.$parent.query(data.query);

          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          const apiUrl =
            this.$parent.$parent.$parent.$store.state.api +
            "checklistexecutions/templates";

          return axios.get(apiUrl + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },

      endPoint: "checklistexecutions",

      dataForm: {},
    };
  },

  methods: {
    query(query) {
      const columns = {
        id: "id",
        checklist_name: "checklist_template_id",
        unit_name: "unit_id",
        status: "status",
      };

      let filters = "";

      $.each(query, function (index, value) {
        if (value !== null && value !== undefined && value !== "") {
          filters += columns[index] + "=" + value + "&";
        }
      });

      return filters;
    },

    loadMobileChecklists() {
      const apiUrl = this.modoAvulso
        ? this.$store.state.api + "checklistexecutions/avulsa"
        : this.$store.state.api + "checklistexecutions/templates";

      const query = this.modoAvulso
        ? ""
        : "?with[]=checklist_template&with[]=unit";

      this.$http.get(apiUrl + query)
        .then(response => {
          if (response.data && response.data.data) {
            this.mobileChecklists = response.data.data;
          }
        })
        .catch(error => {
          console.error("Erro ao carregar checklists:", error);
        });
    },

    getChecklistName(checklist) {
      if (this.modoAvulso) {
        return checklist.nome || "-";
      }
      return checklist.checklist_template && checklist.checklist_template.nome
        ? checklist.checklist_template.nome
        : "-";
    },

    getUnitName(checklist) {
      if (this.modoAvulso) {
        if (checklist.units && checklist.units.length > 0) {
          return checklist.units.map(u => u.name).join(", ");
        }
        return "-";
      }
      return checklist.unit && checklist.unit.name ? checklist.unit.name : "-";
    },

    formatDateTime(dateTime) {
      if (!dateTime) return "-";
      
      return new Date(dateTime).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    getStatusText(status) {
      const statusMap = {
        0: "Disponível",
        "disponivel": "Disponível",
        1: "Aguardando Preenchimento",
        "aguardando_preenchimento": "Aguardando Preenchimento",
        2: "Finalizada",
        "finalizada": "Finalizada",
        3: "Não Preenchida",
        "nao_preenchida": "Não Preenchida",
        4: "Parcialmente Preenchida",
        "parcialmente_preenchida": "Parcialmente Preenchida"
      };
      
      return statusMap[status] || "Desconhecido";
    },

    getStatusClass(status) {
      if (status === 0 || status === "disponivel") return "status-disponivel";
      if (status === 1 || status === "aguardando_preenchimento") return "status-aguardando";
      if (status === 2 || status === "finalizada") return "status-finalizada";
      if (status === 3 || status === "nao_preenchida") return "status-nao-preenchida";
      if (status === 4 || status === "parcialmente_preenchida") return "status-parcial";
      return "status-default";
    },

    executeChecklist(id) {
      if (!id) return;
      if (this.modoAvulso) {
        this.$router.push(`/checklists/view/${id}?avulso=1`);
      } else {
        this.$router.push(`/checklists/view/${id}`);
      }
    },

    async checkAvulsaEnabled() {
      try {
        const meResponse = await this.$http.post("me", { token: localStorage.getItem("token") });
        const isAdmin = meResponse.data.perfil_id == 1;
        this.checklistsAvulsasEnabled = isAdmin || meResponse.data.checklists_avulsas == 1;
      } catch (e) {
        this.checklistsAvulsasEnabled = false;
      }
    },

    toggleModoAvulso() {
      this.modoAvulso = !this.modoAvulso;

      if (this.modoAvulso) {
        this.configurarModoAvulso();
      } else {
        this.configurarModoAgendado();
      }

      this.crudKey++;
      this.loadMobileChecklists();
    },

    configurarModoAvulso() {
      const vm = this;

      this.columns = ["id", "nome_avulso", "actions"];

      this.options.headings = {
        id: "ID",
        nome_avulso: "Checklist",
        actions: "Ações",
      };

      this.options.filterable = ["id", "nome_avulso"];

      this.options.sortable = ["id", "nome_avulso"];

      this.options.templates = Object.assign({}, this.options.templates, {
        nome_avulso: function (h, row) {
          return row.nome || "-";
        },

        unit_names_avulso: function (h, row) {
          if (row.units && row.units.length > 0) {
            return row.units.map(u => u.name).join(", ");
          }
          return "-";
        },

        actions: function (h, row) {
          return h(
            "button",
            {
              class: "btn btn-crud edit",
              attrs: { title: "Executar Checklist Avulsa", type: "button" },
              on: {
                click: () => {
                  if (!row.id) return;
                  vm.$router.push(`/checklists/view/${row.id}?avulso=1`);
                },
              },
            },
            [h("i", { class: "fas fa-play" })]
          );
        },
      });

      this.options.requestFunction = function (data) {
        const apiUrl = vm.$store.state.api + "checklistexecutions/avulsa";
        const params = [];

        if (data.page) params.push("page=" + data.page);
        if (data.limit) params.push("limit=" + data.limit);

        const url = params.length > 0 ? apiUrl + "?" + params.join("&") : apiUrl;

        return axios.get(url).catch(function (e) {
          this.dispatch("error", e);
        }.bind(this));
      };
    },

    configurarModoAgendado() {
      const vm = this;

      this.columns = [
        "id",
        "checklist_name",
        "unit_name",
        "data_hora_agendada",
        "data_hora_fim",
        "status",
        "actions",
      ];

      this.options.headings = {
        id: "ID",
        checklist_name: "Checklist",
        unit_name: "Unidade",
        data_hora_agendada: "Horário Agendado",
        data_hora_fim: "Disponível Até",
        status: "Status",
        actions: "Ações",
      };

      this.options.filterable = ["id", "checklist_name", "unit_name", "status"];

      this.options.sortable = [
        "id",
        "checklist_name",
        "unit_name",
        "data_hora_agendada",
        "data_hora_fim",
        "status",
      ];

      this.options.templates = Object.assign({}, this.options.templates, {
        checklist_name: function (h, row) {
          return row.checklist_template && row.checklist_template.nome
            ? row.checklist_template.nome
            : "-";
        },

        unit_name: function (h, row) {
          return row.unit && row.unit.name ? row.unit.name : "-";
        },

        data_hora_agendada: function (h, row) {
          if (!row.data_hora_agendada) return "-";
          return new Date(row.data_hora_agendada).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
        },

        data_hora_fim: function (h, row) {
          if (!row.data_hora_fim) return "-";
          return new Date(row.data_hora_fim).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
        },

        actions: function (h, row) {
          return h(
            "button",
            {
              class: "btn btn-crud edit",
              attrs: { title: "Executar Checklist", type: "button" },
              on: {
                click: () => {
                  if (!row.id) return;
                  vm.$router.push(`/checklists/view/${row.id}`);
                },
              },
            },
            [h("i", { class: "fas fa-play" })]
          );
        },
      });

      this.options.requestFunction = function (data) {
        const requestData = {};
        const query = vm.query(data.query);

        requestData.params = data;
        requestData.params.query = "";
        requestData.params.with = [];

        const apiUrl =
          vm.$store.state.api + "checklistexecutions/templates";

        return axios.get(apiUrl + "?" + query, requestData).catch(
          function (e) {
            this.dispatch("error", e);
          }.bind(this)
        );
      };
    },
  },

  mounted() {
    this.loadMobileChecklists();
    this.checkAvulsaEnabled();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}

/* Versões Desktop e Mobile */
.desktop-view {
  display: block;
}

.mobile-view {
  display: none;
}

/* === MOBILE STYLES === */
@media (max-width: 950px) {
  .desktop-view {
    display: none !important;
  }

  .mobile-view {
    display: block;
  }

  .mobile-header {
    text-align: center;
    padding: 1.5rem 1rem;
    margin-bottom: 1rem;
  }

  .mobile-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: var(--bs-body-color);
  }

  .mobile-cards-container {
    padding: 0 1rem 2rem;
  }

  /* Card Styling */
  body[data-bs-theme="light"] .checklist-card,
  .light-layout .checklist-card,
  html[data-bs-theme="light"] .checklist-card,
  :not([data-bs-theme="dark"]) .checklist-card {
    background-color: rgba(235, 235, 235, 0.311) !important;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: none;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25),
                0 6px 16px rgba(0, 0, 0, 0.18);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  body[data-bs-theme="dark"] .checklist-card,
  .dark-layout .checklist-card {
    background-color: rgba(21, 22, 35, 0.8) !important;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 
                0 4px 12px rgba(0, 0, 0, 0.4);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .checklist-card:active {
    transform: scale(0.98);
  }

  body[data-bs-theme="dark"] .checklist-card:active,
  .dark-layout .checklist-card:active {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.7), 
                0 2px 8px rgba(0, 0, 0, 0.5);
  }

  .card-header-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 0;
    border-bottom: none;
  }

  body[data-bs-theme="light"] .card-header-line,
  .light-layout .card-header-line,
  html[data-bs-theme="light"] .card-header-line,
  :not([data-bs-theme="dark"]) .card-header-line {
    border-bottom: none;
  }

  .id-badge {
    font-size: 1.15rem;
    font-weight: 700;
    color: rgb(0, 140, 255);
  }

  .status-badge {
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }

  .status-disponivel {
    background: rgba(0, 123, 255, 0.15);
    color: #007bff;
    border: 1px solid rgba(0, 123, 255, 0.3);
  }

  .status-aguardando {
    background: rgba(255, 193, 7, 0.15);
    color: #ffc107;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  .status-finalizada {
    background: rgba(40, 167, 69, 0.15);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.3);
  }

  .status-nao-preenchida {
    background: rgba(220, 53, 69, 0.15);
    color: #dc3545;
    border: 1px solid rgba(220, 53, 69, 0.3);
  }

  .status-parcial {
    background: rgba(255, 193, 7, 0.15);
    color: #ff9800;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }

  .status-default {
    background: rgba(108, 117, 125, 0.15);
    color: #6c757d;
    border: 1px solid rgba(108, 117, 125, 0.3);
  }

  .card-body {
    margin-bottom: 1.5rem;
  }

  .card-info-row {
    margin-bottom: 0.85rem;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    border-left: 2px solid rgba(0, 140, 255, 0.35);
    transition: all 0.2s ease;
  }

  .card-info-row:hover {
    background: rgba(255, 255, 255, 0.07);
    border-left-color: rgba(0, 140, 255, 0.7);
  }

  .card-info-row:last-child {
    margin-bottom: 0;
  }

  body[data-bs-theme="light"] .card-info-row,
  .light-layout .card-info-row,
  html[data-bs-theme="light"] .card-info-row,
  :not([data-bs-theme="dark"]) .card-info-row {
    background: rgba(0, 0, 0, 0.03);
    border-left: 2px solid rgba(0, 140, 255, 0.3);
  }

  body[data-bs-theme="light"] .card-info-row:hover,
  .light-layout .card-info-row:hover,
  html[data-bs-theme="light"] .card-info-row:hover,
  :not([data-bs-theme="dark"]) .card-info-row:hover {
    background: rgba(0, 0, 0, 0.05);
    border-left-color: rgba(0, 140, 255, 0.6);
  }

  .info-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0, 140, 255, 0.7);
    margin-bottom: 0.4rem;
    text-transform: uppercase;
    letter-spacing: 0.8px;
  }

  .info-label i {
    font-size: 0.85rem;
    opacity: 0.6;
  }

  .info-value {
    font-size: 1rem;
    font-weight: 500;
    color: var(--bs-body-color);
    opacity: 0.9;
    padding-left: 0;
    word-break: break-word;
  }

  body[data-bs-theme="dark"] .info-value,
  .dark-layout .info-value {
    opacity: 0.85;
  }

  .card-footer {
    margin-top: 1.75rem;
    padding-top: 0;
    border-top: none;
    background: transparent;
  }

  .btn-execute {
    width: 100%;
    padding: 1rem;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, rgb(0, 140, 255), rgb(0, 110, 255));
    color: white;
    font-size: 1rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 140, 255, 0.3);
  }

  .btn-execute:active {
    transform: scale(0.97);
    box-shadow: 0 2px 8px rgba(0, 140, 255, 0.4);
  }

  .btn-execute i {
    font-size: 0.9rem;
  }

  .no-data-message {
    text-align: center;
    padding: 3rem 1rem;
    color: var(--bs-secondary-color);
  }

  .no-data-message i {
    margin-bottom: 1rem;
    opacity: 0.3;
  }

  .no-data-message p {
    font-size: 1.1rem;
    margin: 0;
  }
}

/* === SMALL MOBILE === */
@media (max-width: 480px) {
  .mobile-title {
    font-size: 1.5rem;
  }

  .checklist-card {
    padding: 1.25rem;
  }

  .id-badge {
    font-size: 1rem;
  }

  .status-badge {
    font-size: 0.7rem;
    padding: 0.35rem 0.75rem;
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.95rem;
  }

  .btn-execute {
    font-size: 0.95rem;
    padding: 0.9rem;
  }
}
</style>